import React, {
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import axiosInstance from "../../../../axios";
import VideoIFrame from "../../../Dashboard/profileManager/VideoPreview";

const ChapterVideo = forwardRef((props, ref) => {
  const videoRef = useRef();

  useEffect(() => {
    if (videoRef.current !== undefined) {
      videoRef.current.currentTime =
        props?.details?.progress !== undefined
          ? props?.details?.progress?.durationCompleted
          : 0;
    }
  }, [videoRef]);

  const handleProgress = (duration) => {
    axiosInstance
      .post(
        "course/progress/update",
        JSON.stringify({
          courseDetailId: props?.details?.courseDetailId,
          fileId: props?.details?.id,
          durationCompleted: duration,
          isFinished: props?.checked,
        }),

        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        console.log(res);
      })
      .catch((res) => console.log(res));
  };

  window.addEventListener("beforeunload", (event) => {
    event.preventDefault();
    const duration = videoRef?.current?.currentTime;
    const videoDuration = duration.toFixed();
    if (props?.checked === false) {
      handleProgress(videoDuration);
    }
  });

  useImperativeHandle(ref, () => ({
    acknowledgeCompleteChapter() {
      if (props?.checked === true) {
        const videoDuration = props?.details?.duration;
        handleProgress(videoDuration);
      } else if (props?.checked === false) {
        const duration = 0;

        handleProgress(duration);
      }
    },
  }));

  const PauseDurationHandler = () => {
    const duration = videoRef?.current?.currentTime;
    const videoDuration = duration.toFixed();
    if (props?.checked == false) {
      handleProgress(videoDuration);
    }
  };

  useEffect(() => {
    document.addEventListener(
      "play",
      function (e) {
        var videos = document.getElementsByTagName("video");
        for (var i = 0, len = videos.length; i < len; i++) {
          if (videos[i] != e.target) {
            videos[i].pause();
          }
        }
      },
      true
    );
  });

  return (
    <>
      <div className="highlight-main">
        <div className="highlight-area">
          <div className="view-video">
            {props.videoLink ? (
              <VideoIFrame url={props.videoLink} />
            ) : (
              <video
                controls={true}
                ref={videoRef}
                onPause={PauseDurationHandler}
              >
                <source src={props.data} type="video/mp4" />
              </video>
            )}
          </div>
        </div>
      </div>
    </>
  );
});
export default ChapterVideo;
